<script setup>

import axios from "@/axios";
import {onMounted, ref, nextTick} from "vue";
import {useRouter} from "vue-router";
import {useLanguageStore} from "@/pinia";
import {formatDate} from "@/plugins/dayjs";
const languageStore = useLanguageStore();
const hasVideo = ref(false);
const router = useRouter();
const props = defineProps(['meetingId'])
const data = ref({});
const title = ref("");

const getData = ()=>{
  axios.get("/api/meeting/"+props.meetingId)
      .then(s=>{
        data.value = s.data;
        let committee = s.data.committeeId != null ?"(" + s.data.committeeId.codeNm + ")" : ""
        title.value = s.data.age.ageTitle + s.data.meetingType.codeNm + committee;
        initPlayer(s.data.liveId);
      }).catch(e=>{
    console.log(e)
  })
}

// YouTube IFrame API 로딩
let player;
let pendingVideoId = null;

function loadYouTubeApi() {
  if (typeof YT !== 'undefined' && YT.Player) return;
  const existing = document.querySelector('script[src="https://www.youtube.com/iframe_api"]');
  if (existing) return;
  const tag = document.createElement('script');
  tag.src = "https://www.youtube.com/iframe_api";
  const firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}

function isYouTubeReady() {
  return typeof YT !== 'undefined' && YT.Player;
}

function initPlayer(videoId) {
  if (!videoId || videoId.trim() === '') {
    hasVideo.value = false;
    return;
  }
  if (isYouTubeReady()) {
    createPlayer(videoId);
  } else {
    pendingVideoId = videoId;
    const prevCallback = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = () => {
      if (prevCallback) prevCallback();
      if (pendingVideoId) {
        createPlayer(pendingVideoId);
        pendingVideoId = null;
      }
    };
  }
}

function createPlayer(videoId) {
  hasVideo.value = true;
  nextTick(() => {
    try {
      player = new YT.Player('player', {
        width: '100%',
        height: '100%',
        videoId: videoId,
        playerVars: {
          'rel': 0,
        },
      });
    } catch (e) {
      console.error('YouTube Player 초기화 실패:', e);
      hasVideo.value = false;
    }
  });
}

const fn_back =()=>{
  router.push({
    path: "/record"
  })
}
onMounted(()=>{
  loadYouTubeApi();
  getData();
})
</script>

<template>

  <div class="detailMeetingArea">
    <div class="meetingContentArea">
      <div class="meetingTop">
        <div class="meetingTitle">{{title}}</div>
        <div class="meetingDateTime">{{formatDate(data.startDt != null ? data.startDt : data.meetingPreDt, 'YYYY-MM-DD HH:mm')}}</div>
      </div>
      <div class="meetingMain">
        <div v-if="hasVideo" class="playerWrapper">
          <div id="player"></div>
        </div>
        <div v-else class="noVideo">
          <v-icon size="64" color="#B0BEC5">mdi-video-off-outline</v-icon>
          <p>{{ languageStore.get('noVideo') }}</p>
        </div>
      </div>
    </div>
    <div class="memoArea">
      <div class="d-flex justify-content-end">
        <v-btn
            color="#052C65"
            @click="fn_back"
        > {{languageStore.get('backToList')}}</v-btn>
      </div>
      <div class="memoTop">
        {{languageStore.get('agenda')}}
      </div>
      <div class="memoContent" v-html='data.memo'>
      </div>
    </div>
  </div>
</template>

<style scoped>
.detailMeetingArea{
  background: white;
  display: flex;
  width: 84vw;
  height: 70vh;
  padding: 30px;
  border-radius: 10px;
}
.meetingTitle{
  font-size: 1.3rem;
  font-weight: bold;
}
.meetingDateTime{
  margin-top: 10px;
  font-size: 0.9rem;
}
.meetingContentArea {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.meetingMain {
  flex: 1;
  min-height: 0;
}
.playerWrapper {
  position: relative;
  width: 100%;
  height: 100%;
}
.playerWrapper :deep(iframe) {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.meetingTop{
  width: 100%;
  height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.memoArea{
  margin-left: 30px;
}
.memoTop{
  width: 400px;
  height: 50px;
  display: flex;
  border-bottom: 1px solid #09223F;
  justify-content: center;
  align-items: center;
  font-size: 1.2rem;
  font-weight: bold;
  margin: 10px;
}
.memoContent{
  padding: 20px 0 10px 10px;
  border: 1px solid lightgray;
  height: 80%;
}
.noVideo {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  background-color: #F5F5F5;
  border-radius: 8px;
  color: #90A4AE;
  font-size: 14px;
  gap: 12px;
}

</style>